import english from './english.json';
import spanish from './spanish.json';
import React, { createContext, useContext, useState } from 'react';

const translations = {
  english: english,
  spanish: spanish
};

const LanguageContext = createContext({
  lang: 'spanish',
  setLang: () => {},
  t: (key) => key
});

export const useTranslation = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem('preferred_language');
      if (stored === 'english' || stored === 'spanish') return stored;
    } catch {}
    return 'spanish';
  });

  const handleSetLang = (newLang) => {
    setLang(newLang);
    try {
      localStorage.setItem('preferred_language', newLang);
    } catch {}
  };

  const t = (key) => translations[lang][key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang: handleSetLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
